import { useContext } from 'react';
import Footer from 'components/Footer/Footer';
import MainSection from 'components/help/categories/main-section/main-section';
import Header from 'components/help/Header/Header';
import Seo from 'components/Seo/Seo';
import { useTranslation } from 'next-i18next';
import { getOgImageURL } from 'services/ogimage';
import type { PartialCategory, PartialSection } from '@doist/help-center-utils';
import type { PageBanner } from 'types/contentful';
import { UserContextV2 } from '@/app/services/providers/contexts/user-context';
type Props = {
  categories: PartialCategory[];
  category: PartialCategory;
  section: PartialSection;
  sectionProvided: boolean;
  pageBanner: PageBanner;
};
export function CategoryPage({
  categories,
  category,
  section,
  sectionProvided = false,
  pageBanner
}: Props) {
  const {
    t,
    i18n
  } = useTranslation('helpcenter');
  const {
    user,
    isAdmin
  } = useContext(UserContextV2);
  const utm_campaign = 'helpcenter';
  const ogimage = getOgImageURL('og-image-help-article.png', i18n.language);
  const seoDescription = sectionProvided && section.description ? section.description : category.description;
  return <>
            <Seo path={sectionProvided ? section.href : category.href} title={sectionProvided ? section.name : category.name} description={seoDescription || undefined} images={[{
      url: ogimage,
      width: 1200,
      height: 628,
      alt: t('seoImageAlt')
    }]} data-sentry-element="Seo" data-sentry-source-file="category-page.tsx" />
            <Header data={{
      user,
      categories
    }} isAdmin={isAdmin} currentPath={section.href} searchBarEnabled mobileSearchBarEnabled showContactUs pageBanner={pageBanner} data-sentry-element="Header" data-sentry-source-file="category-page.tsx" />
            <main>
                <MainSection key={`${category.id}-${i18n.language}}`} categories={categories} category={category} section={section} data-sentry-element="MainSection" data-sentry-source-file="category-page.tsx" />
                <Footer title={t('footerTitle')} utm_campaign={utm_campaign} variant="neutral" data-sentry-element="Footer" data-sentry-source-file="category-page.tsx" />
            </main>
        </>;
}